<template>
  <div class="row">
    <div class="col-md-12">
      <h1>Miembros</h1>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Invitar miembros</h5>
          <h6 class="card-subtitle mb-2 text-muted">Invita miembros nuevos via email para que se unan a tu organización</h6>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-5">
      <b-card no-body>
        <b-tabs card>
          <b-tab :title="'Activos'" no-body>
            <ul class="list-group list-group-flush">
              <li class="list-group-item" v-for="member in members" :key="member.user_admin_id">
                <div class="row">
                  <div class="col-md-1">
                    <b-avatar variant="primary" :text="avatarText(member.name, member.last_name_1)"></b-avatar>
                  </div>
                  <div class="col">
                    {{ member.name }} {{ member.last_name_1}}
                    <br>
                    {{ member.email }}
                  </div>
                  <div class="col">
                    {{member.role}}
                  </div>
                  <div class="col-md-3">
                    <button v-if="member.user_admin_id != user.user_admin_id" type="button" class="btn btn-light action-button">
                      <font-awesome-icon :icon="['fal', 'minus-circle']" /> Eliminar
                    </button>
                    <button v-else type="button" class="btn btn-danger action-button">
                      <font-awesome-icon :icon="['fal', 'times']" /> Abandonar
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </b-tab>
          <b-tab :title="'Pendientes'">
            <h3>Lista Pendientes</h3>
            <pre>
              {{ user }}
            </pre>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard, BTabs, BTab, BAvatar } from 'bootstrap-vue'
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BAvatar
  },
  data () {
    return {
      members: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    avatarText (name, lastName) {
      return `${this.$_.toUpper(name.charAt(0))}${this.$_.toUpper(lastName.charAt(0))}`
    },
    async loadMembers () {
      try {
        const response = await axiosAdelaService.post('/getEnterpriseMembers', JSON.stringify({
          enterprise_id: this.user.enterprise_id
        }))
        if (response.status === 200) {
          this.members = response.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los miembros de la empresa intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadMembers()
  }
}
</script>

<style>

</style>
